import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMalaria.module.css"
import Utils from "../../../../../../../utils/Utils";
import Input from "../../../../../../../components/textbox/Input";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json"

class QuestionarioMalaria extends React.Component {

    state = {
        questionario: {
            chemioprofilassi: "",
            farmaco: "",
            chemioprofilassiCompletata: "",
            motivo: "",
            motivoEffettiCollaterali: "",
            motivoAltro: "",
            protezionePunture: "",
            protezioneZanzariere: "",
            repellentiTesto: "",
            repellenti: "",
            note: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props)

        this.riceviValore = this.riceviValore.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this)
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.questionarioMalaria) {
            let questionario = this.state.questionario
            let questionarioProps = this.props.segnalazioneCopia.schedaSpeciale.questionarioMalaria

            questionario.chemioprofilassi = questionarioProps.chemioprofilassi ? questionarioProps.chemioprofilassi : this.state.questionario.chemioprofilassi
            questionario.farmaco = questionarioProps.farmaco ? questionarioProps.farmaco : this.state.questionario.farmaco
            questionario.chemioprofilassiCompletata = questionarioProps.chemioprofilassiCompletata ? questionarioProps.chemioprofilassiCompletata : this.state.questionario.chemioprofilassiCompletata
            questionario.motivo = questionarioProps.motivo ? questionarioProps.motivo : this.state.questionario.motivo
            questionario.motivoEffettiCollaterali = questionarioProps.motivoEffettiCollaterali ? questionarioProps.motivoEffettiCollaterali : this.state.questionario.motivoEffettiCollaterali
            questionario.motivoAltro = questionarioProps.motivoAltro ? questionarioProps.motivoAltro : this.state.questionario.motivoAltro
            questionario.protezionePunture = questionarioProps.protezionePunture ? questionarioProps.protezionePunture : this.state.questionario.protezionePunture
            questionario.protezioneZanzariere = questionarioProps.protezioneZanzariere ? questionarioProps.protezioneZanzariere : this.state.questionario.protezioneZanzariere
            questionario.repellentiTesto = questionarioProps.repellentiTesto ? questionarioProps.repellentiTesto : this.state.questionario.repellentiTesto
            questionario.repellenti = questionarioProps.repellenti ? questionarioProps.repellenti : this.state.questionario.repellenti
            questionario.note = questionarioProps.note ? questionarioProps.note : this.state.questionario.note

            this.setState({questionario: questionario});

        }

        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setQuestionarioMalaria(this.state.questionario, oggetto)

    }

    createOggettoBE() {
        let questionario = JSON.parse(JSON.stringify(this.state.questionario))
        let questionarioBe = Utils.removeEmptyValueFromObject(questionario)
        return Utils.removeFieldFromObject(questionarioBe, "corretto")
    }

    controlloDati() {
        
        let questionario = this.state.questionario
        questionario.corretto = []

        if (!questionario.chemioprofilassi) {
            questionario.corretto[0] = "Campo \"Chemioprofilassi effettuata in viaggio\" mancante";
        }
        else if (questionario.chemioprofilassi !== "chemioprofilassi2") {
            if(!questionario.farmaco) questionario.corretto[1] = "Campo \"Farmaci\" mancante"

            if(!questionario.chemioprofilassiCompletata)  questionario.corretto[2] = "Campo \"La chemioprofilassi è stata completata per 4 settimane dopo il rientro?\" mancante";
            else if(questionario.chemioprofilassiCompletata === "chemioprofilassiCompletata2"){
                if (!questionario.motivo) questionario.corretto[3] = "Campo \"Se NO, per quale motivo è stata interrotta?\" mancante"
                else if (questionario.motivo === "motivo3" && !questionario.motivoEffettiCollaterali) questionario.corretto[3] = "Campo \"Effetti collaterali\" mancante"
                else if (questionario.motivo === "motivo4" && !questionario.motivoAltro) questionario.corretto[3] = "Campo \"Altro\" mancante"
            }
        }
        if ((this.state.questionario.repellenti === "repellenti2" || this.state.questionario.repellenti === "repellenti3") && !this.state.questionario.repellentiTesto) {
            questionario.corretto[4] = "Campo \"Ha usato repellenti cutanei?\" mancante";
        }

        this.setState({questionario: questionario})

    }

    riceviValore(field, event) {
        let questionario = this.state.questionario
        if (field.currentTarget) {
            questionario[field.currentTarget.id] = field.currentTarget.value
        } else {
            questionario[field] = event.target.value
        }
        this.setState({questionario: questionario})

        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setQuestionarioMalaria(this.state.questionario, oggetto)
    }

    riceviValoreRadioButton(event, field) {
        let questionario = this.state.questionario
        questionario[field] = event

        if (questionario.chemioprofilassiCompletata !== "chemioprofilassiCompletata2") {
            questionario.motivo = ""
            questionario.motivoEffettiCollaterali = ""
            questionario.motivoAltro = ""
        }

        if (field === "motivo" && event !== "motivo3")
            questionario["motivoEffettiCollaterali"] = "";

        if (field === "motivo" && event !== "motivo4")
            questionario["motivoAltro"] = "";
        if (questionario.repellenti === "repellenti1") {
            questionario.repellentiTesto = ""
        }
        this.setState({questionario: questionario})
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setQuestionarioMalaria(this.state.questionario, oggetto)
    }

    render() {

        const {t} = this.props;

        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.Malaria.Questionario.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div style={{marginTop: "1rem"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <p style={{marginTop: "10px"}}>
                                    {t("SchedaFlussoSpeciale.Malaria.Questionario.chemioprofilassiViaggio")}
                                    <span className={stylesWelcome.mandatoryColor}>*</span></p>
                                <div className="row">
                                    <div style={{marginRight: "1rem"}}>
                                        <RadioButton id={"chemioprofilassi1"}
                                                     name={"chemioprofilassi"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.Malaria.Questionario.Viaggio.si")}
                                                     value={"1"}
                                                     onClick={() => this.riceviValoreRadioButton("chemioprofilassi1", "chemioprofilassi")}
                                                     checked={this.state.questionario.chemioprofilassi === "chemioprofilassi1"}
                                        />
                                    </div>
                                    <div style={{marginRight: "1rem"}}>
                                        <RadioButton id={"chemioprofilassi2"}
                                                     name={"chemioprofilassi"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.Malaria.Questionario.Viaggio.no")}
                                                     value={"2"}
                                                     onClick={() => this.riceviValoreRadioButton("chemioprofilassi2", "chemioprofilassi")}
                                                     checked={this.state.questionario.chemioprofilassi === "chemioprofilassi2"}
                                        />
                                    </div>
                                    <div style={{marginRight: "1rem"}}>
                                        <RadioButton id={"chemioprofilassi3"}
                                                     name={"chemioprofilassi"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.Malaria.Questionario.Viaggio.incompleta")}
                                                     value={"3"}
                                                     onClick={() => this.riceviValoreRadioButton("chemioprofilassi3", "chemioprofilassi")}
                                                     checked={this.state.questionario.chemioprofilassi === "chemioprofilassi3"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row" style={{marginTop: "1rem"}}>
                            <div className="col-lg-5">
                                <div className="row">
                                    <div className="col-lg-2">
                                        <p style={{marginTop: "10px"}}>
                                            {t("SchedaFlussoSpeciale.Malaria.Questionario.farmaci")}
                                            {this.state.questionario.chemioprofilassi === "chemioprofilassi1" || this.state.questionario.chemioprofilassi === "chemioprofilassi3" ?
                                                <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                                        </p>
                                    </div>
                                    <div className="col-lg-5">
                                        <Input id={"farmaco"}
                                               onChange={this.riceviValore}
                                               field={"farmaco"}
                                               value={this.state.questionario.farmaco}
                                               placeholder={t("SchedaFlussoSpeciale.Malaria.Questionario.farmaci")}/>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );

        const sezione2 = (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <p style={{marginTop: "10px"}}>
                            {t("SchedaFlussoSpeciale.Malaria.Questionario.chemioprofilassiRientro")}
                            {this.state.questionario.chemioprofilassi === "chemioprofilassi1" || this.state.questionario.chemioprofilassi === "chemioprofilassi3" ?
                                <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                        </p>
                        <div className="row">
                            <div style={{marginRight: "1rem"}}>
                                <RadioButton id={"chemioprofilassiCompletata1"}
                                             name={"chemioprofilassiCompletata"}
                                             style={{color: "black", fontSize: "16px"}}
                                             label={t("SchedaFlussoSpeciale.Malaria.Questionario.Rientro.si")}
                                             value={"1"}
                                             onClick={() => this.riceviValoreRadioButton("chemioprofilassiCompletata1", "chemioprofilassiCompletata")}
                                             checked={this.state.questionario.chemioprofilassiCompletata === "chemioprofilassiCompletata1"}
                                />
                            </div>
                            <div style={{marginRight: "1rem"}}>
                                <RadioButton id={"chemioprofilassiCompletata2"}
                                             name={"chemioprofilassiCompletata"}
                                             style={{color: "black", fontSize: "16px"}}
                                             label={t("SchedaFlussoSpeciale.Malaria.Questionario.Rientro.no")}
                                             value={"2"}
                                             onClick={() => this.riceviValoreRadioButton("chemioprofilassiCompletata2", "chemioprofilassiCompletata")}
                                             checked={this.state.questionario.chemioprofilassiCompletata === "chemioprofilassiCompletata2"}
                                />
                            </div>
                            <div style={{marginRight: "1rem"}}>
                                <RadioButton id={"chemioprofilassiCompletata3"}
                                             name={"chemioprofilassiCompletata"}
                                             style={{color: "black", fontSize: "16px"}}
                                             label={t("SchedaFlussoSpeciale.Malaria.Questionario.Rientro.noto")}
                                             value={"3"}
                                             onClick={() => this.riceviValoreRadioButton("chemioprofilassiCompletata3", "chemioprofilassiCompletata")}
                                             checked={this.state.questionario.chemioprofilassiCompletata === "chemioprofilassiCompletata3"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione3 = (

            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <p style={{marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.Questionario.interrotta")}
                                {this.state.questionario.chemioprofilassiCompletata === "chemioprofilassiCompletata2" ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                            </p>
                            <div className="row">
                                <div style={{marginRight: "1rem"}}>
                                    <RadioButton id={"motivo1"}
                                                 name={"motivo"}
                                                 disabled={this.state.questionario.chemioprofilassiCompletata !== "chemioprofilassiCompletata2"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.Malaria.Questionario.Interrotta.dimenticanza")}
                                                 value={"1"}
                                                 onClick={() => this.riceviValoreRadioButton("motivo1", "motivo")}
                                                 checked={this.state.questionario.motivo === "motivo1"}
                                    />
                                </div>
                                <div style={{marginRight: "1rem"}}>
                                    <RadioButton id={"motivo2"}
                                                 name={"motivo"}
                                                 disabled={this.state.questionario.chemioprofilassiCompletata !== "chemioprofilassiCompletata2"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.Malaria.Questionario.Interrotta.viaggio")}
                                                 value={"2"}
                                                 onClick={() => this.riceviValoreRadioButton("motivo2", "motivo")}
                                                 checked={this.state.questionario.motivo === "motivo2"}
                                    />
                                </div>
                                <div>
                                    <RadioButton id={"motivo3"}
                                                 name={"motivo"}
                                                 disabled={this.state.questionario.chemioprofilassiCompletata !== "chemioprofilassiCompletata2"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.Malaria.Questionario.Interrotta.effetti")}
                                                 value={"3"}
                                                 onClick={() => this.riceviValoreRadioButton("motivo3", "motivo")}
                                                 checked={this.state.questionario.motivo === "motivo3"}
                                    />
                                </div>
                                <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}
                                     style={{marginRight: "1rem"}}>
                                    <Input id={"motivoEffettiCollaterali"}
                                           onChange={this.riceviValore}
                                           style={{height: "2rem", marginTop: "10px"}}
                                           field={"motivoEffettiCollaterali"}
                                           disabled={this.state.questionario.chemioprofilassiCompletata !== "chemioprofilassiCompletata2" || this.state.questionario.motivo !== "motivo3"}
                                           value={this.state.questionario.motivoEffettiCollaterali}
                                           required={this.state.questionario.motivo === "motivo3" ? true : false}
                                           placeholder={t("SchedaFlussoSpeciale.Malaria.Questionario.Interrotta.effetti")}
                                         />
                                </div>
                                <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <RadioButton id={"motivo4"}
                                                 name={"motivo"}
                                                 disabled={this.state.questionario.chemioprofilassiCompletata !== "chemioprofilassiCompletata2"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.Malaria.Questionario.Interrotta.altro")}
                                                 value={"4"}
                                                 onClick={() => this.riceviValoreRadioButton("motivo4", "motivo")}
                                                 checked={this.state.questionario.motivo === "motivo4"}
                                    />
                                </div>
                                <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Input id={"motivoAltro"}
                                           onChange={this.riceviValore}
                                           field={"motivoAltro"}
                                           disabled={this.state.questionario.chemioprofilassiCompletata !== "chemioprofilassiCompletata2" || this.state.questionario.motivo !== "motivo4" }
                                           style={{height: "2rem", marginTop: "10px"}}
                                           value={this.state.questionario.motivoAltro}
                                           required={this.state.questionario.motivo === "motivo4" ? true : false}
                                           placeholder={t("SchedaFlussoSpeciale.Malaria.Questionario.Interrotta.altro")}
                                          />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione4 = (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <p style={{marginTop: "10px"}}>
                            {t("SchedaFlussoSpeciale.Malaria.Questionario.protezione")}
                        </p>
                        <div className="row">
                            <div style={{marginRight: "1rem"}}>
                                <RadioButton id={"protezionePunture1"}
                                             name={"protezionePunture"}
                                             style={{color: "black", fontSize: "16px"}}
                                             label={t("SchedaFlussoSpeciale.Malaria.Questionario.Protezione.si")}
                                             value={"1"}
                                             onClick={() => this.riceviValoreRadioButton("protezionePunture1", "protezionePunture")}
                                             checked={this.state.questionario.protezionePunture === "protezionePunture1"}
                                />
                            </div>
                            <div style={{marginRight: "1rem"}}>
                                <RadioButton id={"protezionePunture2"}
                                             name={"protezionePunture"}
                                             style={{color: "black", fontSize: "16px"}}
                                             label={t("SchedaFlussoSpeciale.Malaria.Questionario.Protezione.no")}
                                             value={"2"}
                                             onClick={() => this.riceviValoreRadioButton("protezionePunture2", "protezionePunture")}
                                             checked={this.state.questionario.protezionePunture === "protezionePunture2"}
                                />
                            </div>
                            <div style={{marginRight: "1rem"}}>
                                <RadioButton id={"protezionePunture3"}
                                             name={"protezionePunture"}
                                             style={{color: "black", fontSize: "16px"}}
                                             label={t("SchedaFlussoSpeciale.Malaria.Questionario.Protezione.nonSpecificato")}
                                             value={"3"}
                                             onClick={() => this.riceviValoreRadioButton("protezionePunture3", "protezionePunture")}
                                             checked={this.state.questionario.protezionePunture === "protezionePunture3"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione5 = (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <p style={{marginTop: "10px"}}>
                                    {t("SchedaFlussoSpeciale.Malaria.Questionario.zoneRischio")}
                                </p>
                            </div>
                            <div className="row">
                                <div style={{marginRight: "1rem"}}>
                                    <RadioButton id={"protezioneZanzariere1"}
                                                 name={"protezioneZanzariere"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.Malaria.Questionario.ZoneRischio.mai")}
                                                 value={"1"}
                                                 onClick={() => this.riceviValoreRadioButton("protezioneZanzariere1", "protezioneZanzariere")}
                                                 checked={this.state.questionario.protezioneZanzariere === "protezioneZanzariere1"}
                                    />
                                </div>
                                <div style={{marginRight: "1rem"}}>
                                    <RadioButton id={"protezioneZanzariere2"}
                                                 name={"protezioneZanzariere"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.Malaria.Questionario.ZoneRischio.saltuariamente")}
                                                 value={"2"}
                                                 onClick={() => this.riceviValoreRadioButton("protezioneZanzariere2", "protezioneZanzariere")}
                                                 checked={this.state.questionario.protezioneZanzariere === "protezioneZanzariere2"}
                                    />
                                </div>
                                <div style={{marginRight: "1rem"}}>
                                    <RadioButton id={"protezioneZanzariere3"}
                                                 name={"protezioneZanzariere"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.Malaria.Questionario.ZoneRischio.sempre")}
                                                 value={"3"}
                                                 onClick={() => this.riceviValoreRadioButton("protezioneZanzariere3", "protezioneZanzariere")}
                                                 checked={this.state.questionario.protezioneZanzariere === "protezioneZanzariere3"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione6 = (
            <div style={{marginTop: "1rem"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <p style={{marginTop: "10px"}}>
                                    {t("SchedaFlussoSpeciale.Malaria.Questionario.repellenti")}
                                </p>
                                <div className={"col-lg-3"}>
                                    <Input id={"repellentiTesto"}
                                           onChange={this.riceviValore}
                                           field={"repellentiTesto"}
                                           required={this.state.questionario.repellenti === "repellenti2" || this.state.questionario.repellenti === "repellenti3"}
                                           value={this.state.questionario.repellentiTesto}
                                           placeholder={t("SchedaFlussoSpeciale.Malaria.Questionario.repellenti")}/>
                                </div>
                            </div>
                            <div className="row">
                                <div style={{marginRight: "1rem"}}>
                                    <RadioButton id={"repellenti1"}
                                                 name={"repellenti"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.Malaria.Questionario.Repellenti.mai")}
                                                 value={"1"}
                                                 onClick={() => this.riceviValoreRadioButton("repellenti1", "repellenti")}
                                                 checked={this.state.questionario.repellenti === "repellenti1"}
                                    />
                                </div>
                                <div style={{marginRight: "1rem"}}>
                                    <RadioButton id={"repellenti2"}
                                                 name={"repellenti"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.Malaria.Questionario.Repellenti.saltuariamente")}
                                                 value={"2"}
                                                 onClick={() => this.riceviValoreRadioButton("repellenti2", "repellenti")}
                                                 checked={this.state.questionario.repellenti === "repellenti2"}
                                    />
                                </div>
                                <div style={{marginRight: "1rem"}}>
                                    <RadioButton id={"repellenti3"}
                                                 name={"repellenti"}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 label={t("SchedaFlussoSpeciale.Malaria.Questionario.Repellenti.sempre")}
                                                 value={"3"}
                                                 onClick={() => this.riceviValoreRadioButton("repellenti3", "repellenti")}
                                                 checked={this.state.questionario.repellenti === "repellenti3"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione7 = (
            <div style={{marginTop: "1rem"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <p style={{color: "#1b7ea9"}}>
                                {t("SchedaFlussoSpeciale.Malaria.Questionario.note")}
                            </p>
                            <Input type={"textarea"} class="form-group" rows="3"
                                   id={"note"}
                                   onChange={this.riceviValore}
                                   field={"note"}
                                   value={this.state.questionario.note}
                                   placeholder={t("SchedaFlussoSpeciale.Malaria.Questionario.note")}/>
                        </div>
                    </div>
                </div>
            </div>
        );


        return (
            <div>
                {sezione1}
                {sezione2}
                {sezione3}
                {sezione4}
                {sezione5}
                {sezione6}
                {sezione7}
            </div>

        )
    }

}

export default withTranslation('common')(QuestionarioMalaria)
